<h5>{{ 'fence.materials.boards-for' | translate:{installation: installation.name.toLowerCase()} }}</h5>

<div class="materials-container">
  <!-- Affichage des types de lame -->
  @for (board of boards; track board.id) {
    <div (click)="selectBoard(board)"
         [class.active]="isBoardSelected(board)"
         class="materials-card">
      <img [src]="baseImgURL + board.icon" alt="board-img" class="board-img" />
      <p class="board-title">
        {{ currentLang === 'fr' ? board.nameFr : board.nameEn }}

        @if (board.tooltip) {
          <a class="casto-tooltip"
             (click)="openTooltip(board, $event)">?</a>
        }
      </p>
    </div>
  } @empty {
    <ng-casto-loader></ng-casto-loader>
  }
</div>

<!-- Lames -->
@if (configurationInstallationHasBoards) {
  <h5 class="colors-title">
    {{ colorsActiveCount }} {{ 'fence.materials.color-choices' | translate }}
  </h5>

  <div class="board-mixing-options">
    <div class="colors-container">
      @for (color of colors; track color.id) {
        <div (click)="selectColor(color)"
             [class.active]="isColorSelected(color)"
             [class.disabled-card]="color.isDisabled"
             class="colors-card">
          <img [src]="baseImgURL + color.icon" alt="color-img" class="color-img" />
          @if (currentLang === 'fr') {
            <p class="color-title">{{ color.nameFr }}</p>
          } @else {
            <p class="color-title">{{ color.nameEn }}</p>
          }
        </div>
      }
    </div>

    @if (configurationInstallationContainBoardMix) {
      <div>
        <h5 class="colors-title">{{ colorsActiveCount }} {{ 'fence.materials.color-choices' | translate }}</h5>
        <div class="form-row">
          <div class="form-label">
            <label [for]="'mixedCount' + boardMixSecondaryBoard.boardId">
              {{ 'fence.materials.mixed-count-label' | translate: { boardName: secondaryBoardName | lowercase } }}
            </label>
          </div>
          <div class="form-input">
            <div class="number">
              <input
                (change)="changeNbLamesMixte($event)"
                [ngModel]="boardMixSecondaryBoardQuantity"
                [min]="1"
                [max]="maxBoard"
                autocorrect="off"
                [id]="'mixedCount' + boardMixSecondaryBoard.boardId"
                spellcheck="false"
                type="number" />
            </div>
          </div>
        </div>

        <div class="form-row">
          <div class="form-label">
            <label [for]="'isPrimaryBoardFirst' + boardMixSecondaryBoard.boardId">
              {{ 'fence.materials.reverse-laying-blades' | translate }}
            </label>
          </div>
          <div class="form-switch">
            <span class="mr-2">{{ 'fence.configuration.no' | translate }}</span>
            <div class="custom-control custom-switch">
              <input
                (change)="changeBoardMixOrder()"
                [ngModel]="!isBoardMixAscOrder"
                class="custom-control-input"
                [id]="'isPrimaryBoardFirst' + boardMixSecondaryBoard.boardId"
                type="checkbox" />
              <label class="custom-control-label" [for]="'isPrimaryBoardFirst' + boardMixSecondaryBoard.boardId">{{
                  'fence.configuration.yes' | translate
                }}</label>
            </div>
          </div>
        </div>
      </div>
    }
  </div>
}
